import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import { TownsAutoComplete } from "@limitless/expert";
const Towns = ({
  towns,
  classes,
  onTownChange,
  selectedTown
}) => {
  const renderTowns = () => {
    if ((towns === null || towns === void 0 ? void 0 : towns.length) > 0) {
      return /*#__PURE__*/React.createElement(Grid, {
        className: classes.state
      }, /*#__PURE__*/React.createElement(TownsAutoComplete, {
        classes: {
          root: classes.autoCompleteRoot
        },
        disabled: false,
        id: "stateInputField",
        label: "State",
        placeholder: "State",
        towns: towns,
        selectedTown: selectedTown.value,
        onValueChange: onTownChange,
        background: "yellow",
        isMandatory: true,
        maxMenuHeight: 200,
        minMenuHeight: 200
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderTowns());
};
export default Towns;
Towns.propTypes = {
  towns: PropTypes.array,
  classes: PropTypes.object,
  selectedTown: PropTypes.object,
  enabled: PropTypes.bool,
  onTownChange: PropTypes.func.isRequired,
  locale: PropTypes.string
};